import axios from "axios";

let cacheConfig: null | Record<string, any> = null;

const getJsConfig = async (pageUrl: string) => {
  if (cacheConfig !== null) return;
  
  try {
    const pageUrlOrigin = new URL(pageUrl).origin
    const configUrl = pageUrlOrigin + "/project/js/config.json"
    const res = await axios.get<string>(configUrl, {
      headers: {
        "Cache-Control": "no-store",
      },
      transformResponse: x => x,
    });
    cacheConfig = JSON.parse(res.data);
  } catch (e) {
    console.log(e)
  }
}

export {
  getJsConfig,
  cacheConfig as config,
}
